// extracted by mini-css-extract-plugin
module.exports = {"input":"ColorInput_input__1LxWM","container":"ColorInput_container__1l8-p","picker":"ColorInput_picker__1jh69"};